import { SPORT } from 'shared/constants';

export const T = [];

export type AthleteFormValues = {
	department: string;
	editor: string;
	editor_note: string;
	player_information: {
		profile_picture: string;
		first_name: string;
		last_name: string;
		racquet_brand: string;
		gender: string;
		date_of_birth: string;
		status: string;
		athlete_id: string;
		circuit_level: string;
		playing_hand: string;
		category1: string;
		category2: string;
		category3: string;
		country_id: number;
		country: string;
		tournament: string;
		tournament_note: string;
		club: string;
		brand: string;
		yonex_contact_person_id: string;
		sport: string;
		email: string;
		phone_number: string;
	};

	contract_information: {
		type: string;
		contract_note: string;
		//retainer_amount: number;
		retainer_currency: string;
		retainer_term_start: string;
		retainer_term_end: string;
	};
	guardian_information: {
		first_name: string;
		last_name: string;
		email: string;
		relation: string;
		telephone_number: string;
	};
	equipment_information: {
		racquet_brand: string;
		racquet_model_name_code: string;
		racquet_color_name_code: string;
		racquet_grip_size: string;
		racquet_additional_details: string;
		string_brand: string;
		string_model_name_code: string;
		string_color_name_code: string;
		string_size: string;
		string_additional_details: string;
		grip_size: string;
		grip_brand: string;
		grip_model_name_code: string;
		grip_color_name_code: string;
		grip_additional_details: string;
		apparel_brand: string;
		apparel_shirt_size: string;
		apparel_short_size: string;
		apparel_jacket_size: string;
		apparel_pants_size: string;
		apparel_model_name_code: string;
		apparel_additional_details: string;
		shoes_brand: string;
		shoes_model_name_code: string;
		shoes_additional_details: string;
		shoes_size: string;
	};
	equipment_memo: {
		equipment_category: string;
		note: string;
	}[];
	agent_information: {
		first_name: string;
		last_name: string;
		email: string;
		telephone_number: string;
		agent_agency: string;
	};
	performance_profile: {
		performance_toggle: boolean;
		team_yonex_senior_level: string;
		legends_vision: string;
		team_yonex_current_performance_level: string;
		training_age: number;
		potential_grade: string;
		x_factor: string;
		recruit_chance: string;
		// is_junior: boolean;
	};
	social_medias: ISocialMedia[];
	marketability_current: string;
	marketability_potential: string;
	kpis: [
		{
			kpi_id: number;
			value: number;
		}
	];
	kpi_groups: [
		{
			kpi_group_name: string;
			note: string;
			tournament: string;
		}
	];
	facebook: boolean;
	instagram: boolean;
	tikTok: boolean;
	x: boolean;
	weibo: boolean;
	youTube: boolean;
	xfactor: boolean;
	player_videos: IPlayerVideos[];
	notify_editor_info: IEditor;
};

export interface IEditor {
	content: string;
	user_ids: string[];
}

export const defaultValues: AthleteFormValues = {
	department: '',
	editor: '',
	editor_note: '',
	player_information: {
		profile_picture: '',
		first_name: '',
		last_name: '',
		racquet_brand: '',
		gender: '',
		date_of_birth: '',
		status: '',
		athlete_id: '',
		circuit_level: '',
		playing_hand: '',
		category1: '',
		category2: '',
		category3: '',
		country_id: 0,
		country: '',
		tournament: '',
		tournament_note: '',
		club: '',
		brand: '',
		yonex_contact_person_id: '',
		sport: '',
		email: '',
		phone_number: ''
	},
	contract_information: {
		type: '',
		//retainer_amount: 0,
		contract_note: '',
		retainer_currency: '',
		retainer_term_start: '',
		retainer_term_end: ''
	},
	equipment_memo: [],
	equipment_information: {
		racquet_brand: '',
		racquet_model_name_code: '',
		racquet_color_name_code: '',
		racquet_grip_size: '',
		racquet_additional_details: '',
		string_brand: '',
		string_model_name_code: '',
		string_color_name_code: '',
		string_size: '',
		string_additional_details: '',
		grip_size: '',
		grip_model_name_code: '',
		grip_color_name_code: '',
		grip_additional_details: '',
		grip_brand: '',
		apparel_brand: '',
		apparel_shirt_size: '',
		apparel_model_name_code: '',
		apparel_short_size: '',
		apparel_jacket_size: '',
		apparel_pants_size: '',
		apparel_additional_details: '',
		shoes_brand: '',
		shoes_model_name_code: '',
		shoes_additional_details: '',
		shoes_size: ''
	},
	guardian_information: {
		first_name: '',
		last_name: '',
		email: '',
		relation: '',
		telephone_number: ''
	},
	agent_information: {
		first_name: '',
		last_name: '',
		email: '',
		telephone_number: '',
		agent_agency: ''
	},
	performance_profile: {
		performance_toggle: false,
		team_yonex_senior_level: '',
		legends_vision: '',
		team_yonex_current_performance_level: '',
		training_age: 0,
		potential_grade: '',
		x_factor: '',
		recruit_chance: ''
		// is_junior: true
	},
	marketability_current: '',
	marketability_potential: '',
	kpis: [
		{
			kpi_id: 0,
			value: 0
		}
	],
	kpi_groups: [
		{
			kpi_group_name: '',
			note: '',
			tournament: ''
		}
	],
	facebook: false,
	instagram: false,
	tikTok: false,
	x: false,
	weibo: false,
	youTube: false,
	xfactor: false,
	social_medias: [],
	player_videos: [],
	notify_editor_info: {} as IEditor
};

export const enum playerModal {
	ADDED_PLAYER = 'Added player',
	EDITOR_COMMENT = 'Editor Comment'
}
export const enum excelModal {
	IMPORT_POPUP = 'Import Popup',
	EXPORT_POPUP = 'Export Popup'
}

export interface IAthleteFormValues {
	player_information: IPlayerInformation;
	player_videos: IPlayerVideos;
	contract_information: IContractInformation;
	guardian_information: IGuardianInformation;
	agent_information: IAgentInformation;
	performance_profile: IPerformanceProfile;
	kpis: IKpis;
	kpi_groups: IKpiGroups;
	marketability_current: string;
	marketability_potential: string;
	player_quick_note: string;
}

export interface IPlayerInformation {
	profile_picture: string;
	first_name: string;
	last_name: string;
	racquet_brand: string;
	gender: string;
	date_of_birth: string;
	status: string;
	athlete_id: string;
	circuit_level: string;
	playing_hand: string;
	category1: string;
	category2: string;
	category3: string;
	country_id: number;
	sports: string;
	continent: string;
}

export interface IPlayerVideos {
	tournament_name: string;
	comment: string;
	video_url: string;
	creation_date: string;
	file?: File;
	scout_id?: string;
	id?: string;
}

export interface IContractInformation {
	type: string;
	//retainer_amount: number;
	//retainer_currency: string;
	contract_note: string;
	id: string;
	start_date: string;
	end_date: string;
}

export interface IGuardianInformation {
	first_name: string;
	last_name: string;
	relation: string;
	email: string;
	telephone_number_country_code: string;
	telephone_number: string;
}

export interface IAgentInformation {
	first_name: string;
	last_name: string;
	email: string;
	agent_agency: string;
	telephone_number_country_code: string;
	telephone_number: string;
}

export interface IPerformanceProfile {
	senior_level: string;
	legends_vision: string;
	future_star_level: string;
	training_age: number;
	potential_grade: string;
}

export interface IKpis {
	reduce(arg0: (acc: any, current: any) => any, arg1: {}): unknown;
	length: number;
	kpi_id: number;
	value: number;
}

export interface IKpiGroups {
	map(arg0: (kpiNote: any) => { note: any; tournament: any; kpi_group_name: any }): unknown;
	length: number;
	kpi_group_name: string;
	note: string;
	tournament: string;
}

export interface ISocialMedia {
	name: string;
	profile_link: string;
	follower_count: string;
	last_updated_on: string;
}
export interface IAddedPlayer {
	created_at: string;
	updated_at: string;
	deleted_at: string;
	id: string;
	profile_picture: string;
	first_name: string;
	last_name: string;
	racquet_brand: string;
	gender: string;
	date_of_birth: string;
	status: string;
	athlete_id: string;
	circuit_level: string;
	playing_hand: string;
	category1: string;
	category2: string;
	category3: string;
	contract_type: string;
	contract_retainer_amount: number;
	contract_retainer_currency: string;
	contract_retainer_term_start: string | null;
	contract_retainer_term_end: string | null;
	guardian_first_name: string;
	guardian_last_name: string;
	guardian_relation: string;
	guardian_email: string;
	guardian_telephone_number: string;
	agent_first_name: string;
	agent_last_name: string;
	agent_email: string;
	agent_telephone_number: string;
	team_yonex_future_star_level: string;
	training_age: number;
	potential_grade: string;
	x_factor: string;
	team_yonex_senior_level: string;
	legends_vision: string;
	country: ICountry;
	sports: string;
	marketability_current: string;
	marketability_potential: string;
	brand: string;
}

export interface ICountry {
	id: number;
}

export interface IPlayerNote {
	note: string;
	tournament: string;
	kpi_group_name: string;
}

export interface ICountryOption {
	label: string;
	value: number;
}

export interface IVideoInfo {
	id: string;
	video_url: string;
	creation_date: string;
	comment: string;
	tournament_name: string;
	player_id: string;
	user_id: string;
	user_name: string;
	user_last_name: string;
	scout_id: any;
	scout_name: any;
	scout_last_name: any;
	video_size: number;
	file?: File;
	athlete_name?: string;
}

export interface IKpiValueNew {
	id: number;
	name: string;
}

export interface IKpiDataNew {
	title: string;
	kpisData: IKpiValueNew[];
	isAddNote: boolean;
}

export interface IKpiResponse {
	kpi_id: number;
	value: number;
}

export interface IKpiDetails {
	created_at: string;
	updated_at: string;
	deleted_at: string;
	id: number;
	name: string;
	kpi_group: string;
}

export interface IUserScout {
	id: string;
	name: string;
	last_name: string;
	email: string;
	phone_number: any;
	coworker_title: string;
	department_group: string;
	department: any;
	internal_department: string;
	access_type: string;
	sports: string;
	user_link_modules: string[];
}

export interface IEditorResponse {
	id: string;
	name: string;
	last_name: string;
	email: string;
	phone_number: string;
	coworker_title: string;
	department_group: string;
	department: string;
	internal_department: string;
	access_type: string;
	sports: string;
	user_link_modules: IUserLinkModule[];
}

export interface IUserLinkModule {
	id: string;
	module: string;
}

export interface ITennisFormValues {
	player_information: {
		profile_picture: string;
		first_name: string;
		last_name: string;
		brand: string;
		gender: string;
		birth_year: number;
		country_id: number;
		racket_model: string;
		string_model: string;
		recruit_chance: string;
		player_email: string;
		player_phone_number: string;
		player_contact_person: string;
		yonex_contact_person_id: string;
	};
	marketability_current: string;
	marketability_potential: string;
	contract_information: {
		contract_type: string;
		contract_end_date: string;
	};
	player_videos: [
		{
			scout_id: string;
			tournament_name: string;
			comment: string;
			video_url: string;
			creation_date: string;
			title: string;
		}
	];
	facebook: boolean;
	instagram: boolean;
	tikTok: boolean;
	x: boolean;
	weibo: boolean;
	youTube: boolean;
	social_medias: [];
	notify_editor_info: {
		content: string;
		user_ids: [];
	};
	kpis: [
		{
			kpi_id: number;
			value: number;
		}
	];
	player_quick_note: string;
}

export const tennisDefaultValues: ITennisFormValues = {
	player_information: {
		profile_picture: '',
		first_name: '',
		last_name: '',
		brand: '',
		gender: '',
		birth_year: 0,
		country_id: 0,
		racket_model: '',
		string_model: '',
		recruit_chance: '',
		player_email: '',
		player_phone_number: '',
		player_contact_person: '',
		yonex_contact_person_id: ''
	},
	contract_information: {
		contract_type: '',
		contract_end_date: ''
	},
	marketability_current: '',
	marketability_potential: '',

	player_videos: [
		{
			scout_id: '',
			tournament_name: '',
			comment: '',
			video_url: '',
			creation_date: '',
			title: ''
		}
	],
	social_medias: [],
	facebook: false,
	instagram: false,
	tikTok: false,
	x: false,
	weibo: false,
	youTube: false,
	notify_editor_info: {
		content: '',
		user_ids: []
	},
	kpis: [
		{
			kpi_id: 0,
			value: 0
		}
	],
	player_quick_note: ''
};

export type ISportSelectionProps = {
	sports: ISport[];
	chooseSport?: string;
	onSelect: (sport: string) => void;
};

export type ISport = {
	name: string;
	icon: any; // Assuming this will be an SVG or some other React component
};

export interface IAthleteDropdown {
	label: string;
	value: string;
	sport: SPORT;
	phone_number: string;
	email: string;
}
